import { useState } from "react";
import "./ProductsModule.scss";
import { ProductsLoadingAnimation } from "../animations/ProductsLoadingAnimation/ProductsLoadingAnimation";
import { ProductPage } from "./ProductPage/ProductPage";
import { ProductsBuy } from "./ProductsBuy/ProductsBuy";
import { ProductOnlineShop } from "./ProductsOnlineShop/ProductsOnlineShop";
import { ProductStoreShop } from "./ProductsStoreShop/ProductsStoreShop";

export const ProductsModule = ({
  aiResults,
  getProducts,
  onBackClick,
  onExitClick,
}) => {
  const [productsData, setProductsData] = useState(undefined);
  const [step, setStep] = useState(0);

  return (
    <>
      {step === 0 && (
        <ProductsLoadingAnimation
          apiPromise={() =>
            getProducts().then((resData) => setProductsData(resData))
          }
          onFinish={() => setStep(1)}
        />
      )}
      {productsData !== undefined && productsData !== null && step === 1 && (
        <ProductPage
          aiResults={aiResults}
          recommendedData={productsData}
          onBackClick={onBackClick}
          onBuyClick={() => setStep(2)}
          onExitClick={onExitClick}
        />
      )}
      {step === 2 && (
        <ProductsBuy
          onExitClick={onExitClick}
          onBackClick={() => setStep(1)}
          onOnlineShopClick={() => setStep(3)}
          onStoreShopClick={() => setStep(4)}
        />
      )}
      {step === 3 && (
        <ProductOnlineShop
          products={productsData}
          onExitClick={onExitClick}
          onBackClick={() => setStep(2)}
        />
      )}

      {step === 4 && (
        <ProductStoreShop
          onExitClick={onExitClick}
          onBackClick={() => setStep(2)}
        />
      )}
    </>
  );
};
